import { useCallback } from "react";
import { StyledTable, StyledTh, StyledTr } from "../../../../../../../styled";
import { deepClone } from "../../../../../../../utils";
import {
  type IMedicalDynamicSection,
  IMedicalHeader,
} from "../MedicalSections.model";
import MedicalSectionWrapper from "../MedicalSectionWrapper";
import MedicalDynamicRow from "./MedicalDynamicRow";
interface Props extends IMedicalDynamicSection {
  disabled?: boolean;
  history?: boolean;
}
const MedicalDynamic = ({
  name,
  headers,
  rows,
  sectionId,
  dataKey,
  disabled,
  history,
}: Props) => {
  const parsedHeaders = useCallback(() => {
    const items: IMedicalHeader[] = deepClone(headers);
    if (!items.some(item => item.name === "Action") && !history)
      items.push({ name: "Action", width: 100 });
    return items;
  }, [headers, history]);
  return (
    <MedicalSectionWrapper name={name} dataKey={dataKey} disabled={history}>
      <div style={{ overflowY: "auto" }}>
        <StyledTable>
          <thead>
            <StyledTr>
              {parsedHeaders().map(header => (
                <StyledTh
                  key={header.name + Math.random()}
                  width={header.width}>
                  {header.name}
                </StyledTh>
              ))}
            </StyledTr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <MedicalDynamicRow
                key={`${name}-row-${i}`}
                index={i}
                sectionId={sectionId}
                rowsLength={rows.length}
                dataKey={dataKey}
                row={row}
                history={history}
              />
            ))}
          </tbody>
        </StyledTable>
      </div>
    </MedicalSectionWrapper>
  );
};
export default MedicalDynamic;
